var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrangeError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0469 23.102H2.38786C1.68324 23.102 1.0516 22.738 0.698256 22.1284C0.352143 21.5312 0.346852 20.8268 0.683706 20.1957L10.0133 2.7193C10.3474 2.09347 10.9845 1.71985 11.7174 1.71985C12.4503 1.71985 13.0874 2.09347 13.4215 2.7193L22.7511 20.1956C23.088 20.8267 23.0827 21.5313 22.7365 22.1284C22.3832 22.738 21.7516 23.102 21.0469 23.102Z",
    fill: "#FF6425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7511 20.1954L13.4215 2.71905C13.0874 2.09323 12.4504 1.7196 11.7174 1.7196V23.1017H21.047C21.7516 23.1017 22.3833 22.7378 22.7365 22.1282C23.0826 21.531 23.088 20.8265 22.7511 20.1954Z",
    fill: "#FF4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7174 20.2369C10.7449 20.2369 9.95374 19.4458 9.95374 18.4733C9.95374 17.5009 10.7449 16.7097 11.7174 16.7097C12.6898 16.7097 13.481 17.5009 13.481 18.4733C13.481 19.4458 12.6898 20.2369 11.7174 20.2369Z",
    fill: "#FFF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7174 14.9461C10.7449 14.9461 9.95374 14.1549 9.95374 13.1825V9.36861C9.95374 8.39615 10.7449 7.60498 11.7174 7.60498C12.6898 7.60498 13.481 8.39615 13.481 9.36861V13.1825C13.481 14.1549 12.6899 14.9461 11.7174 14.9461Z",
    fill: "#FFF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7175 7.60498H11.7174V14.9461H11.7175C12.69 14.9461 13.4811 14.1549 13.4811 13.1825V9.36861C13.4811 8.39619 12.6899 7.60498 11.7175 7.60498Z",
    fill: "#DAD0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7175 16.7097H11.7174V20.2369H11.7175C12.6899 20.2369 13.4811 19.4458 13.4811 18.4733C13.4811 17.5009 12.6899 16.7097 11.7175 16.7097Z",
    fill: "#DAD0CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5652,
    height: 22.5652,
    fill: "white",
    transform: "translate(0.434814)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrangeError);
export default __webpack_public_path__ + "static/media/icon-orange-error.ba002a80aa10be6dda022da8ec098f23.svg";
export { ForwardRef as ReactComponent };